import { replace } from 'ramda';
import { useState } from 'react';
import {
  ZipCodeMessage,
  ZipCodeSearchArea,
  ZipCodeSearchAreaButton,
  ZipCodeSearchInnerContainer,
  ZipCodeSearchTextbox
} from './ZipCodeInput.styles';

type OwnProps = {
  id: string;
  onSubmit: (searchTerm: string) => void;
  onChange: (searchTerm: string) => void;
  searchTerm: string;
};

export default function ZipCodeInput({
  id,
  onSubmit,
  onChange,
  searchTerm
}: OwnProps) {
  const [isFocused, setIsFocused] = useState(false);
  const [isValid, setIsValid] = useState(true);

  return (
    <ZipCodeSearchArea>
      <ZipCodeSearchInnerContainer>
        <div
          className={
            !isValid
              ? 'float-container error'
              : isFocused || searchTerm
              ? 'float-container active'
              : 'float-container'
          }
          style={{ flex: 5 }}
        >
          <label htmlFor={`${id}`} className="ziplabel">
            <span className="zip-text"> ZIP CODE </span>
            {!isValid ? <span className="error-marker">!</span> : null}
          </label>
          <ZipCodeSearchTextbox
            id={id}
            onFocus={() => {
              setIsFocused(true);
            }}
            onBlur={() => {
              setIsFocused(false);
            }}
            pattern="\d{1,5}"
            maxLength={5}
            value={searchTerm}
            onChange={e => {
              searchTerm = replace(/[^\d]/g, '', e.target.value);
              onChange(searchTerm);
            }}
            type="text"
          />
        </div>

        <ZipCodeSearchAreaButton
          data-analytics-id="Zip Code Search"
          onClick={() => {
            if (searchTerm.length === 5) {
              onSubmit(searchTerm);
              setIsValid(true);
            } else {
              setIsValid(false);
            }
          }}
          role="button"
        >
          GO
        </ZipCodeSearchAreaButton>
      </ZipCodeSearchInnerContainer>

      {!isValid ? (
        <ZipCodeMessage>
          <span>Please enter a valid zip code </span>{' '}
        </ZipCodeMessage>
      ) : null}
    </ZipCodeSearchArea>
  );
}
